const statusCodes = {
  HTTP_200_OK: 200,
  HTTP_201_CREATED: 201,
  HTTP_204_NO_CONTENT: 204,
  HTTP_400_BAD_REQUEST: 400,
  HTTP_401_UNAUTHORIZED: 401,
  HTTP_404_NOT_FOUND: 404,
  HTTP_422_UNPROCESSABLE_ENTITY: 422,
  HTTP_500_INTERNAL_SERVER_ERROR: 500,
};

export const errorDetails = {
  REGISTER_USER_ALREADY_EXISTS: 'REGISTER_USER_ALREADY_EXISTS',
  LOGIN_BAD_CREDENTIALS: 'LOGIN_BAD_CREDENTIALS',
};

export default statusCodes;
